export enum SignUpPageVisitedEventContext {
  TemplateReferral = 'Template Referral',
  TemplateReferralIframe = 'Template Referral IFrame',
  WatchDemoTR = 'Watch Demo TR',
  WatchDemoNTR = 'Watch Demo NTR',
}
